import {has, remove, set} from '@acng/frontend-bounty/dom/attribute.js';

/**
 * @deprecated use debug from "@acng/frontend-bounty/dom/debug.js"
 * @param {Element} element
 */
export const VERBOSE = (element) => {
  return has(element, 'debug');
};

/**
 * Make a stargazer compile callback that simply changes an attribute name and outputs a console warning.
 *
 * @param {string} newName
 *
 * @param {(oldValue: string, element: Element) => string} map
 * Optionally modify the attribute value or the whole element.
 */
export const mapDeprecatedAttribute = (newName, map = (value) => value) => {
  /**
   * @param {string} oldName
   */
  return (oldName) => {
    /**
     * @param {Element} element
     * @param {string} value
     * @param {import("@acng/frontend-stargazer").RegistryEngine} compiler
     */
    return (element, value, compiler) => {
      DEBUG: console.warn(`[${oldName}] is deprecated - use [${newName}]`, {compiler, element});
      set(element, newName, map(value, element));
      remove(element, oldName);
    };
  };
};
